import Polyglot from 'node-polyglot';

import polyglotOnMissingKey from '../polyglotOnMissingKey';

/* global __LP_FORM_ERRORS__, __LP_LANG__ */

const errorsMessage = new Polyglot({
    allowMissing: true,
    onMissingKey: polyglotOnMissingKey,
});

if (typeof __LP_FORM_ERRORS__ !== 'undefined') {
    errorsMessage.extend({
        [__LP_LANG__]: __LP_FORM_ERRORS__,
    });
} else {
    errorsMessage.extend(require('../localization.fallback').errorsMessage);
}

export default errorsMessage;
